import React, {Component, createRef} from 'react'
import {withRouter} from 'react-router-dom'

import ImageGallery from '@limulus/react-image-gallery'
import '@limulus/react-image-gallery/styles/css/image-gallery-no-icon.css'
import throttle from 'lodash.throttle'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faImages, faPlay, faPause, faChevronLeft, faChevronRight
} from '@fortawesome/free-solid-svg-icons'

import {
  selectAlbumPhotoList,
  selectPhotoBrowserItems,
  selectIndexForPhoto,
  selectPhotoForIndex,
} from './albumSelectors'

const slideDuration = 300

class PhotoBrowser extends Component {
  constructor (props) {
    super(props)
    this.state = {lifeCycle: 'opening'}
    this.imageGalleryRef = createRef()
    this.goToPreviousPhoto = this.goToPreviousPhoto.bind(this)
    this.goToNextPhoto = this.goToNextPhoto.bind(this)
    this.goToIndex = this.goToIndex.bind(this)
    this.slideToPhoto = throttle(this.slideToPhoto.bind(this), slideDuration+100)
    this.close = this.close.bind(this)
    this.onTransitionEnd = this.onTransitionEnd.bind(this)
  }

  componentDidUpdate (prevProps) {
    const {photo} = this.props
    if (photo !== prevProps.photo) {
      this.slideToPhoto(photo)
    }
  }

  componentDidMount () {
    setTimeout(() => this.setState({lifeCycle: 'open'}), 200)
  }

  goToPreviousPhoto () {
    const {album, photo} = this.props
    const index = selectIndexForPhoto(album, photo)
    return this.goToIndex(index - 1)
  }

  goToNextPhoto () {
    const {album, photo} = this.props
    const index = selectIndexForPhoto(album, photo)
    return this.goToIndex(index + 1)
  }

  goToIndex (index) {
    const {album, photo, history} = this.props
    if (index < 0 || index >= selectAlbumPhotoList(album).length) return
    if (photo === selectPhotoForIndex(album, index)) return
    history.push(`../${selectPhotoForIndex(album, index)}/`)
  }

  slideToPhoto (photo) {
    const {album} = this.props
    const imageGallery = this.imageGalleryRef.current
    const toIndex = selectIndexForPhoto(album, photo)
    const curIndex = imageGallery.getCurrentIndex()
    if (toIndex === curIndex) return
    imageGallery._unthrottledSlideToIndex(toIndex)
  }

  close () {
    this.setState({ lifeCycle: 'closing' })
  }

  onTransitionEnd (e) {
    const {history} = this.props
    if (this.state.lifeCycle === 'closing') {
      history.push('..')
    }
  }

  render () {
    const {album, photo} = this.props

    return (
      <div
        className={`photo-browser ${this.state.lifeCycle}`}
        onTransitionEnd={this.onTransitionEnd}
      >
        <ImageGallery
          ref={this.imageGalleryRef}
          items={selectPhotoBrowserItems(album)}
          startIndex={selectIndexForPhoto(album, photo)}
          lazyLoad={true}
          infinite={false}
          showThumbnails={false}
          showFullscreenButton={false}
          stopPropagation={true}
          preventDefaultTouchmoveEvent={true}
          slideDuration={slideDuration}
          onSlide={this.goToIndex}
          renderItem={_renderItem}
          renderLeftNav={(_, disabled) => (
            <button
              className="image-gallery-left-nav"
              disabled={disabled}
              aria-label="Previous Slide"
              onClick={this.goToPreviousPhoto}
            >
              <FontAwesomeIcon icon={faChevronLeft} size="1x" color="white" />
            </button>
          )}
          renderRightNav={(_, disabled) => (
            <button
              className="image-gallery-right-nav"
              disabled={disabled}
              aria-label="Next Slide"
              onClick={this.goToNextPhoto}
            >
              <FontAwesomeIcon icon={faChevronRight} size="1x" color="white" />
            </button>
          )}
          renderPlayPauseButton={(onClick, isPlaying) => (
            <button
              type="button"
              className="image-gallery-play-button"
              onClick={onClick}
            >
              <FontAwesomeIcon
                icon={isPlaying ? faPause : faPlay}
                size="3x"
                color="white"
              />
            </button>
          )}
          renderCustomControls={() => (
            <button
              className="image-gallery-custom-action"
              onClick={this.close}
            >
              <FontAwesomeIcon icon={faImages} size="3x" color="white" />
            </button>
          )}
        />
      </div>
    )
  }
}

// From react-image-gallery, but slimmed down to our use case and
// fixed to avoid extra requests in Safari
const supportsSrcSet = 'srcset' in document.createElement('img')
function _renderItem (item) {
  return (
    <div className='image-gallery-image'>
      {
        <img
          /*
            Order of `sizes`, `srcSet` and `src` is important to avoid
            unnecessary requests of every image in a `srcSet` in Safari.
            Similarly, not adding `src` when we have a `srcSet` and the
            browser supports it avoids an unnecessary request in Safari
            when `lazyLoad` is in effect. Safari seems super eager
            to start downloading images the moment an `HTMLImageElement`
            `src` or `srcSet` is updated.
          */
          sizes={item.sizes}
          srcSet={item.srcSet}
          src={item.srcSet && supportsSrcSet ? null : item.original}

          alt={item.originalAlt}
          title={item.originalTitle}
        />
      }

      {
        item.description &&
          <span className='image-gallery-description'>
            {item.description}
          </span>
      }
    </div>
  )
}

export default withRouter(PhotoBrowser)



// WEBPACK FOOTER //
// ./src/PhotoBrowser.js